import BackgroundImage from '@/components/BackgroundImage.vue'
import { api } from '@/galaxy-cruise/api'
import { Series } from '@/galaxy-cruise/api_interface'
import { asyncAlert } from '@/galaxy-cruise/components/AsyncAlert'
import { goNextGalaxy, reloadSession, reloadMessages } from '@/galaxy-cruise/utils'
import { Component, Vue, Watch } from "vue-property-decorator"
import { store } from '../../../../store'
import MessagesWindow from "../MessagesWindow/index.vue"
import Confirm from './Confirm.vue'
import moment from 'moment'
import Campaigns from './campaigns/index.vue'

@Component({
  components: { BackgroundImage, Campaigns },
})
export default class extends Vue {
  series = this.gc.series

  get gc() {
    return store.galaxyCruise
  }

  get level() {
    return this.gc.session!.quest.level
  }

  async logout() {
    const axios = api.default
    await axios.delete('../api/v1/session')
    this.gc.session = null
    this.$router.push('/login')
  }

  get node_env() {
    return process.env.NODE_ENV
  }

  @Watch('series')
  async onSeriesChange(series: Series, oldSeries: Series) {
    if (this.gc.series === series) {
      return
    }

    const globe = store.currentGlobe()

    if (series === 'training') {
      const button = await asyncAlert({
        component: Confirm, raiseOnClose: true, props: {
          html: this.$t('move_to_practice_mode'),
          buttons: [this.$t('new_game'), this.$t('continue')],
        },
      }).catch(() => -1)
      switch (button) {
        case -1:
          this.series = oldSeries
          return
        case 0:
          const axios = api.default
          await axios.post('../api/v1/answers/clear', { series })
      }
    }

    this.gc.series = series

    globe.viewFactory.jumpTo({}, { duration: 0 })
    await reloadSession()

    await goNextGalaxy(5000)
  }

  @Watch('gc.series')
  onGcSeriesChange() {
    this.series = this.gc.series
  }

  private async showMessagesWindow() {
    const { last, messages } = await reloadMessages()
    await asyncAlert({
      component: MessagesWindow, props: {
        initialLastMessageCheck: moment(last).toISOString(),
      },
    })
  }

  get showMessagesLink() {
    return this.gc.messages.length > 0
  }

  private mobileMenu: null | string = null
  @Watch('mobileMenu')
  private onMobileMenuChange() {
    if (this.mobileMenu !== null) {
      const m = this.mobileMenu!.match(/(.*):(.*)/)!
      const actions = {
        course: (course: Series) => {
          this.series = course
        },
        method: (m: string) => {
          // @ts-ignore
          this[m]()
        },
        'a-href': (href: string) => {
          window.open(href)
        },
        'router-link-to': (to: string) => {
          this.$router.push(to)
        },
      }
      // @ts-ignore
      actions[m[1]](m[2])
    }
    this.mobileMenu = null
  }
}
